import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_BANKDATA,
  DELETE_BANKDATA,
  UPDATE_BANKDATA,
  ADD_NEW_BANKDATA,
} from "./actionType";

import {
  getBankDataSuccess,
  getBankDataFail,
  deleteBankDataSuccess,
  deleteBankDataFail,
  updateBankDataSuccess,
  updateBankDataFail,
  addBankDataSuccess,
  addBankDataFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getBankDataApi,
  updateBankDataApi,
  deleteBankDataApi,
  addNewBankDataApi
} from "../../helpers/backend_helper";

function* getBankData({ payload: bankData }) {
  try {
    const response = yield call(getBankDataApi, bankData);
    yield put(getBankDataSuccess(GET_BANKDATA, response.data));
  } catch (error) {
    yield put(getBankDataFail(GET_BANKDATA, error));
  }
}

function* onUpdateBankData({ payload: bankData }) {
  try {
    const response = yield call(updateBankDataApi, bankData);
    yield put(updateBankDataSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateBankDataFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteBankData({ payload: bankData }) {
  try {
    const response = yield call(deleteBankDataApi, bankData);
    yield put(deleteBankDataSuccess({ bankData, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteBankDataFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewBankData({ payload: bankData }) {
  try {
    const response = yield call(addNewBankDataApi, bankData);
    yield put(addBankDataSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addBankDataFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetBankData() {
  yield takeEvery(GET_BANKDATA, getBankData);
}

export function* watchUpdateBankData() {
  yield takeEvery(UPDATE_BANKDATA, onUpdateBankData);
}

export function* watchDeleteBankData() {
  yield takeEvery(DELETE_BANKDATA, onDeleteBankData);
}

export function* watchAddNewBankData() {
  yield takeEvery(ADD_NEW_BANKDATA, onAddNewBankData);
}

function* bankDataSaga() {
  yield all([
    fork(watchGetBankData),
    fork(watchDeleteBankData),
    fork(watchUpdateBankData),
    fork(watchAddNewBankData)
  ]);
}

export default bankDataSaga;
